<template>
    <transition name="viewer-fade">
        <div tabindex="-1" ref="el-image-viewer__wrapper" class="el-image-viewer__wrapper" :style="{ 'z-index': zIndex }">
            <div class="el-image-viewer__mask" @click.self="handleMaskClick"></div>
            <!-- CLOSE -->
            <span class="el-image-viewer__btn el-image-viewer__close" @click="hide">
                <i class="el-icon-close"></i>
            </span>
            <!-- ARROW -->
            <template v-if="!isSingle">
                <span class="el-image-viewer__btn el-image-viewer__prev" :class="{ 'is-disabled': !infinite && isFirst }"
                    @click="prev">
                    <i class="el-icon-arrow-left" />
                </span>
                <span class="el-image-viewer__btn el-image-viewer__next" :class="{ 'is-disabled': !infinite && isLast }"
                    @click="next">
                    <i class="el-icon-arrow-right" />
                </span>
            </template>
            <!-- ACTIONS -->
            <div class="el-image-viewer__btn el-image-viewer__actions">
                <div class="el-image-viewer__actions__inner">
                    <i class="el-icon-zoom-out" @click="handleActions('zoomOut')"></i>
                    <i class="el-icon-zoom-in" @click="handleActions('zoomIn')"></i>
                    <i class="el-icon-refresh-left" @click="handleActions('anticlocelise')"></i>
                    <i class="el-icon-refresh-right" @click="handleActions('clocelise')"></i>
                </div>
            </div>
            <!-- CANVAS -->
            <div class="el-image-viewer__canvas">
                <img v-for="(url, i) in urlList" v-if="i === index" ref="img" class="el-image-viewer__img" :key="i"
                    :src="url" :style="imgStyle" id="img-viewer" @load="handleImgLoad" @error="handleImgError"
                    @mousedown="handleMouseDown">
            </div>
        </div>
    </transition>
</template>
<script>
export default {
    props: {
        urlList: {
            type: Array,
            default: () => []
        },
        zIndex: {
            type: Number,
            default: 3000
        },
        onSwitch: {
            type: Function,
            default: () => { }
        },
        onClose: {
            type: Function,
            default: () => { }
        },
        initialIndex: {
            type: Number,
            default: 0
        },
        appendToBody: {
            type: Boolean,
            default: true
        },
        maskClosable: {
            type: Boolean,
            default: true
        },
        tags: {
            type: String,
            default: 'detail'
        }
    },

    data() {
        return {
            index: this.initialIndex,
            isShow: false,
            infinite: true,
            loading: false,
            transform: {
                scale: 1,
                deg: 0,
                offsetX: 0,
                offsetY: 0,
                enableTransition: false
            },
            mousewheelEventName: ''
        }
    },
    computed: {
        isSingle() {
            return this.urlList.length <= 1;
        },
        isFirst() {
            return this.index === 0;
        },
        isLast() {
            return this.index === this.urlList.length - 1;
        },
        currentImg() {
            return this.urlList[this.index];
        },
        imgStyle() {
            const { scale, deg, offsetX, offsetY, enableTransition } = this.transform;
            const style = {
                transform: 'scale(' + scale + ') rotate(' + deg + 'deg)',
                transition: enableTransition ? 'transform .3s' : '',
                'margin-left': offsetX + 'px',
                'margin-top': offsetY + 'px'
            };
            style.maxWidth = style.maxHeight = '100%';
            return style;
        }
    },
    watch: {
        index: {
            handler: function (val) {
                this.reset();
                this.onSwitch(val);
            }
        },
        currentImg(val) {
            this.$nextTick(_ => {
                const $img = this.$refs.img[0];
                if (!$img.complete) {
                    this.loading = true;
                }
            });
        }
    },
    methods: {
        hide() {
            this.deviceSupportUninstall();
            this.onClose();
        },
        deviceSupportInstall() {
            let self = this
            this._keyDownHandler = this.rafThrottle(e => {
                const keyCode = e.keyCode;
                switch (keyCode) {
                    // ESC
                    case 27:
                        this.hide();
                        break;
                    // LEFT_ARROW
                    case 37:
                        this.prev();
                        break;
                    // UP_ARROW
                    case 38:
                        this.handleActions('zoomIn');
                        break;
                    // RIGHT_ARROW
                    case 39:
                        this.next();
                        break;
                    // DOWN_ARROW
                    case 40:
                        this.handleActions('zoomOut');
                        break;
                }
            });
            this._mouseWheelHandler = this.rafThrottle(e => {
                const delta = e.wheelDelta ? e.wheelDelta : -e.detail;
                if (delta > 0) {
                    this.handleActions('zoomIn', {
                        zoomRate: 0.015,
                        enableTransition: false
                    });
                } else {
                    this.handleActions('zoomOut', {
                        zoomRate: 0.015,
                        enableTransition: false
                    });
                }
            });

            document.addEventListener('keydown', this._keyDownHandler);
            document.addEventListener(this.mousewheelEventName, this._mouseWheelHandler);
        },
        deviceSupportUninstall() {
            document.removeEventListener('keydown', this._keyDownHandler);
            document.removeEventListener(this.mousewheelEventName, this._mouseWheelHandler);
            this._keyDownHandler = null;
            this._mouseWheelHandler = null;
            let ele = document || document.body
            ele.oncontextmenu = function (e) {
                return true
            };
        },
        handleImgLoad(e) {
            this.loading = false;
        },
        handleImgError(e) {
            this.loading = false;
            e.target.alt = '加载失败';
        },
        handleMouseDown(e) {
            if (this.loading || (e.button !== 0 && e.button !== 2)) return;
            if (e.button == 2) {
                let self = this
                let ele = document || document.body
                ele.oncontextmenu = function (e) {
                    if (e.target.id == 'img-viewer') {
                        self.$alert('是否保存该图片', '保存', {
                            confirmButtonText: '确定',
                            callback: action => {
                                if (action == 'confirm') {
                                    self.downs()
                                }
                            }
                        });
                        return false; //禁止
                    } else {
                        return true; //不禁止
                    }
                };
            }

            const { offsetX, offsetY } = this.transform;
            const startX = e.pageX;
            const startY = e.pageY;
            this._dragHandler = this.rafThrottle(ev => {
                this.transform.offsetX = offsetX + ev.pageX - startX;
                this.transform.offsetY = offsetY + ev.pageY - startY;
            });
            document.addEventListener('mousemove', this._dragHandler);
            document.addEventListener('mouseup', ev => {
                document.removeEventListener('mousemove', this._dragHandler);
            });

            e.preventDefault();
        },
        handleMaskClick() {
            if (this.maskClosable) {
                this.hide();
            }
        },
        reset() {
            this.transform = {
                scale: 1,
                deg: 0,
                offsetX: 0,
                offsetY: 0,
                enableTransition: false
            };
        },
        prev() {
            if (this.isFirst && !this.infinite) return;
            const len = this.urlList.length;
            this.index = (this.index - 1 + len) % len;
        },
        next() {
            if (this.isLast && !this.infinite) return;
            const len = this.urlList.length;
            this.index = (this.index + 1) % len;
        },
        handleActions(action, options = {}) {
            if (this.loading) return;
            const { zoomRate, rotateDeg, enableTransition } = {
                zoomRate: 0.2,
                rotateDeg: 90,
                enableTransition: true,
                ...options
            };
            const { transform } = this;
            switch (action) {
                case 'zoomOut':
                    if (transform.scale > 0.2) {
                        transform.scale = parseFloat((transform.scale - zoomRate).toFixedRoundUp(3));
                    }
                    break;
                case 'zoomIn':
                    transform.scale = parseFloat((transform.scale + zoomRate).toFixedRoundUp(3));
                    break;
                case 'clocelise':
                    transform.deg += rotateDeg;
                    break;
                case 'anticlocelise':
                    transform.deg -= rotateDeg;
                    break;
            }
            transform.enableTransition = enableTransition;
        },
        rafThrottle(fn) {
            let locked = false;
            return function (...args) {
                if (locked) return;
                locked = true;
                window.requestAnimationFrame(_ => {
                    fn.apply(this, args);
                    locked = false;
                });
            };
        },
        downloadIamge(imgsrc, name) { //下载图片地址和图片名
            var image = new Image();
            // 解决跨域 Canvas 污染问题
            image.setAttribute("crossOrigin", "anonymous");
            image.onload = function () {
                var canvas = document.createElement("canvas");
                canvas.width = image.width;
                canvas.height = image.height;
                var context = canvas.getContext("2d");
                context.drawImage(image, 0, 0, image.width, image.height);
                // var url = canvas.toDataURL("image/jpg"); //得到图片的base64编码数据
                // var a = document.createElement("a"); // 生成一个a元素
                // var event = new MouseEvent("click"); // 创建一个单击事件
                // a.download = name; // 设置图片名称
                // a.href = url; // 将生成的URL设置为a.href属性
                // a.dispatchEvent(event); // 触发a的单击事件

                canvas.toBlob((blob) => {
                    var url = URL.createObjectURL(blob)
                    var a = document.createElement("a"); // 生成一个a元素
                    var event = new MouseEvent("click"); // 创建一个单击事件
                    a.download = name; // 设置图片名称
                    a.href = url; // 将生成的URL设置为a.href属性
                    a.dispatchEvent(event); // 触发a的单击事件
                    URL.revokeObjectURL(url)
                }, "image/jpeg")
            }
            image.src = imgsrc;
        },
        downs() {
            let i = this.index
            if (this.tags == 'detail') i = this.index
            let name = '图片_' + new Date().getTime() + i + '.jpg'
            let src = this.urlList[this.index] + '?' + new Date().getTime()
            this.downloadIamge(src, name)
        }
    },
    mounted() {
        this.deviceSupportInstall();
        this.mousewheelEventName = !!window.navigator.userAgent.match(/firefox/i) ? 'DOMMouseScroll' : 'mousewheel';
        if (this.appendToBody) {
            document.body.appendChild(this.$el);
        }
        // add tabindex then wrapper can be focusable via Javascript
        // focus wrapper so arrow key can't cause inner scroll behavior underneath
        this.$refs['el-image-viewer__wrapper'].focus();
    },
    destroyed() {
        // if appendToBody is true, remove DOM node after destroy
        if (this.appendToBody && this.$el && this.$el.parentNode) {
            this.$el.parentNode.removeChild(this.$el);
        }
    }
}
</script>

<style>
.el-image-viewer__mask {
    background-color: rgba(0, 0, 0, 0.5);
    opacity: 1;
}

.el-image-viewer__actions__inner i {
    font-size: 16px;
}

.el-image-viewer__index {
    left: 50%;
    top: 30px;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    /*width: 60px;*/
    height: 30px;
    padding: 0 20px;
    background-color: rgba(96, 98, 102, 0.5);
    border-radius: 15px;
    /*opacity: .8;*/
    position: absolute;
    z-index: 1;
}

.el-image-viewer__index p {
    font-size: 14px;
    color: #fff;
    line-height: 30px;
    text-align: center;
}

.el-image-viewer__close,
.el-image-viewer__prev,
.el-image-viewer__next {
    background-color: #409EFF;
}

.el-image-viewer__actions__inner i {
    font-size: 16px;
}

.el-image-viewer__close i,
.el-image-viewer__prev i,
.el-image-viewer__next i,
.el-image-viewer__actions__inner i,
.el-icon-loading {
    font-size: 22px;
}

.el-image-viewer__wrapper {
    z-index: 3000 !important;
}

.el-message-box__wrapper {
    z-index: 3001 !important;
}

.customer-box {
    width: 100%;
    /* height: calc(100% - 90px); */
    height: 100%;
}

.customer-scroll {
    /* height: calc(100% - 32px); */
    height: 100%;
}

.customer-img-box {
    padding: 15px 15px 0;
    height: calc(100% - 30px);
    display: grid;
    justify-content: space-between;
    grid-template-columns: repeat(auto-fill, 200px);
    grid-gap: 10px;
}

.customer-img-item {
    width: 180px;
    padding: 8px 8px 0;
    background-color: #fff;
    border-radius: 5px;
    box-shadow: 0px 0px 10px 0px rgba(204, 204, 204, 0.7);
    margin-bottom: 15px;
}

.customer-img-img {
    width: 180px;
    height: 240px;
    margin-bottom: 8px;
    position: relative;
}

.customer-img-item .el-image {
    width: 180px;
    height: 240px;
}

.zanwu {
    text-align: center;
    font-size: 14px;
    color: #999;
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-40%, -50%);
}
</style>
   
